import { DeliveryAction } from '../models/deliveries';

export interface CityConfigDto {
  city_id: number;
  is_dropoff_required: boolean;
  landing_page: string;
}

export interface CityConfigsDto {
  configs: {
    [cityId: string]: CityConfigDto;
  };
}

export interface ServiceAreaConfigDto {
  service_area_id: number;
  banner_text?: string;
}

export enum FullfillmentType {
  ON_DEMAND = 'ON_DEMAND',
  DEDICATED = 'DEDICATED'
}

export enum AccessTypeDto {
  PORTAL = 'PORTAL',
  API = 'API'
}

export enum PaymentMethodTypeTransporter {
  WALLET = 'WALLET',
  CARD = 'CARD',
  INVOICE = 'INVOICE'
}

export enum MerchantStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}

export interface MerchantConfigDTO {
  merchant_id: number;
  signup_timestamp: number;
  status: MerchantStatus;
  contact_details: {
    preferred_contact_number: string;
  };
  fulfillment_types: FullfillmentType[];
  is_drop_off_mandatory: boolean;
  is_otp_enabled: boolean;
  is_customer_phone_number_mandatory: boolean;
  is_orderId_in_order_reference_mandatory: boolean;
  access_types: AccessTypeDto[];
  payment_configurations: {
    available_payment_methods: PaymentMethodTypeTransporter[];
    primary_payment_method: number | null;
    secondary_payment_method: number | null;
  };
  fulfillment_configurations: {
    standard_fulfillment_distance: number;
    custom_fulfillment_distance?: number;
    cfd_start_timestamp?: number;
    cfd_end_timestamp?: number;
    is_cfd_enabled?: boolean;
  };
  default_delivery_instruction: DeliveryAction;
  is_verified_by_ops: boolean;
  is_credit_card_on_delivery_allowed: boolean;
}
